export default __webpack_public_path__ + "static/media/brs.6f9cbe41.svg";